import { useSignUpRequest } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { useQuery as useFindStateQuery } from "@faire/web-api--source/endpoints/www/api/retailer/find-country-state/get-hooks";

export const useGetCountryState = () => {
  const [{ matched_business, country, postal_code }] = useSignUpRequest([
    "matched_business",
    "country",
    "postal_code",
  ]);

  const placeId = matched_business?.id;

  const { data: countryState, isLoading } = useFindStateQuery({
    country,
    postalCode: postal_code,
    googlePlaceId: placeId,
  });

  return { countryState, isLoading };
};
